const router = [
	{
		component: require('@/pages/containers/home/index'),
		path: '/'
	},
	// 我的采购单
	{
		component: require('@/pages/containers/purchaseOrder/index'),
		path: '/purchaseOrder'
	},
	// 我的采购单详情
	{
		component: require('@/pages/containers/purchaseOrder/detail'),
		path: '/purchaseOrderDetail'
	},
	// 发采购
	{
		component: require('@/pages/containers/purchaseSend/index'),
		path: '/purchaseSend'
	},
	// 我的订阅
	{
		component: require('@/pages/containers/subscribe/index'),
		path: '/subscribe'
	},
	// 我的供应
	{
		component: require('@/pages/containers/supple/index'),
		path: '/supple'
	},
	// 发布供应
	{
		component: require('@/pages/containers/releaseSupple/index'),
		path: '/releaseSupple'
	},
	// 修改密码
	{
		component: require('@/pages/containers/revisePassword/index'),
		path: '/revisePassword'
	},
	// 个人认证
	{
		component: require('@/pages/containers/authentication/personal'),
		path: '/authentication/personal'
	},
	// 个人认证申请
	{
		component: require('@/pages/containers/authentication/personal-apply'),
		path: '/authentication/papply'
	},
	// 企业认证
	{
		component: require('@/pages/containers/authentication/enterprise'),
		path: '/authentication/enterprise'
	},
	// 申请记录入口
	{
		component: require('@/pages/containers/authentication/apply'),
		path: '/authentication/apply'
	},
	// 申请记录列表
	{
		component: require('@/pages/containers/authentication/apply-list'),
		path: '/authentication/applylist'
	},
	// 企业认证第一步
	{
		component: require('@/pages/containers/authentication/step1'),
		path: '/authentication/step1'
	},
	// 企业认证第二步
	{
		component: require('@/pages/containers/authentication/step2'),
		path: '/authentication/step2'
	},
	// 企业认证第三步
	{
		component: require('@/pages/containers/authentication/step3'),
		path: '/authentication/step3'
	},
	// 申请加入企业
	{
		component: require('@/pages/containers/authentication/join'),
		path: '/authentication/join'
	},
	// 账户信息
	{
		component: require('@/pages/containers/userInfo/index'),
		path: '/userInfo'
	},
	// 绑定手机号
	{
		component: require('@/pages/containers/userBind/bind_phone'),
		path: '/bind_phone'
	},
	// 更换手机号
	{
		component: require('@/pages/containers/userBind/replace_phone'),
		path: '/replace_phone'
	},
	// 更换手机2
	{
		component: require('@/pages/containers/userBind/replace_phone_2'),
		path: '/replace_phone2'
	},
	// 绑定邮箱
	{
		component: require('@/pages/containers/userBind/bind_email'),
		path: '/bind_email'
	},
	{
		component: require('@/pages/containers/userBind/bind_trader'),
		path: '/bind_trader'
	},
	// 设置密码
	{
		component: require('@/pages/containers/login/set_password'),
		path: '/set_password'
	},
	// 登录
	{
		component: require('@/pages/containers/login/index'),
		path: '/login'
	},
	// 注册
	{
		component: require('@/pages/containers/login/register'),
		path: '/register'
	},
	// 企业状态页
	{
		component: require('@/pages/containers/auth/auth_status'),
		path: '/auth/status'
	},
	// 企业认证-申请
	{
		component: require('@/pages/containers/auth/component_auth'),
		path: '/auth/component'
	},
	// 企业认证-步骤一
	{
		component: require('@/pages/containers/auth/componentAuth_step1'),
		path: '/auth/step1'
	},
	// 企业认证-步骤2
	{
		component: require('@/pages/containers/auth/componentAuth_step2'),
		path: '/auth/step2'
	},
	// 企业认证-步骤3
	{
		component: require('@/pages/containers/auth/componentAuth_step3'),
		path: '/auth/step3'
	},
	// 实名认证
	{
		component: require('@/pages/containers/auth/realnameAuth'),
		path: '/auth/realname'
	},
	// 忘记密码
	{
		component: require('@/pages/containers/userBind/forget_password'),
		path: '/forget_password'
	},
	// 询盘  买家卖家
	{
		component: require('@/pages/containers/inquiryMessage/identity'),
		path: '/inquiry/identity'
	},
	// 询盘 列表
	{
		component: require('@/pages/containers/inquiryMessage/index'),
		path: '/inquiry/message'
	},
	// 询盘子列表
	{
		component: require('@/pages/containers/inquiryMessage/list'),
		path: '/inquiry/list'
	},
	// 询盘详情
	{
		component: require('@/pages/containers/inquiryMessage/details'),
		path: '/inquiry/details'
	},
	// 采购询盘详情
	{
		component: require('@/pages/containers/inquiryMessage/purchaseDetails'),
		path: '/inquiry/purchaseDetails'
	},
	// 用户收藏
	{
		component: require('@/pages/containers/user/collect'),
		path: '/user/collect'
	},
	// 店铺管理 用户收藏
	{
		component: require('@/pages/containers/store/information/index'),
		path: '/store/information'
	},
	// 店铺管理 修改链接
	{
		component: require('@/pages/containers/store/information/editLink'),
		path: '/store/editLink'
	},
	// 店铺管理 编辑店铺介绍
	{
		component: require('@/pages/containers/store/information/editIntroduce'),
		path: '/store/editIntroduce'
	},
	// 店铺管理 编辑优选客户
	{
		component: require('@/pages/containers/store/information/editCustomer'),
		path: '/store/editCustomer'
	},
	// 店铺管理 添加优选客户
	{
		component: require('@/pages/containers/store/information/addCustomer'),
		path: '/store/addCustomer'
	},
	{
		component: require('@/pages/containers/store/information/addCustomer'),
		path: '/store/addSupperlier'
	},
	// 店铺管理 编辑供应商
	{
		component: require('@/pages/containers/store/information/editSupplier'),
		path: '/store/EditSupplier'
	},
	// 店铺管理 联系方式
	{
		component: require('@/pages/containers/store/contact/index'),
		path: '/store/contact'
	},
	// 店铺管理 联系方式添加
	{
		component: require('@/pages/containers/store/contact/add'),
		path: '/store/contact/add'
	},

	// 店铺管理 商品管理
	{
		component: require('@/pages/containers/store/commodityMangement/index'),
		path: '/store/commodityMangement'
	},
	// 店铺管理 商品发布
	{
		component: require('@/pages/containers/store/commodityMangement/release'),
		path: '/store/commodityMangement/release'
	},
	// 店铺管理 商品分类管理
	{
		component: require('@/pages/containers/store/commodityMangement/types'),
		path: '/store/commodityMangement/types'
	},
	// 店铺管理 订单管理
	{
		component: require('@/pages/containers/store/order/index'),
		path: '/store/order'
	},
	// 消息通知
	{
		component: require('@/pages/containers/notification/index'),
		path: '/notification',
		title: '通知'
	},
	// 消息详情
	{
		component: require('@/pages/containers/notification/detail'),
		path: '/notification/detail'
	},
	// 在线课堂
	{
		component: require('@/pages/containers/class/index'),
		path: '/class',
		title: '在线课堂'
	},
	// 专家库-入驻流程
	{
		component: require('@/pages/containers/expert/index'),
		path: '/expert',
		title: '专家库'
	},
	// 专家库-主页
	{
		component: require('@/pages/containers/expert/home'),
		path: '/expert/home',
		title: '专家库'
	},
	// 专家库-编辑
	{
		component: require('@/pages/containers/expert/edit'),
		path: '/expert/edit',
		title: '编辑信息'
	},
	// 专家-自我介绍
	{
		component: require('@/pages/containers/expert/introduction'),
		path: '/expert/introduction',
		title: '自我介绍'
	},
	{
		component: require('@/pages/containers/expert/goodat'),
		path: '/expert/goodat',
		title: '擅长领域'
	},
	// 优料库-产品中心
	{
		component: require('@/pages/containers/ylk/index'),
		path: '/u',
		title: '优料库-产品中心'
	},
	// 优料库-录入产品
	{
		component: require('@/pages/containers/ylk/list'),
		path: '/u/list',
		backgroundColor: '#f5f5f5'
	},
	// 优料库-添加/编辑配方
	{
		component: require('@/pages/containers/ylk/formula/index'),
		path: '/u/formula',
		title: '填写配方'
	},
	// 优料库-配方介绍
	{
		component: require('@/pages/containers/ylk/formula/introduction'),
		path: '/u/formula/introduction',
		title: '配方介绍'
	},
	// 优料库-工艺流程
	{
		component: require('@/pages/containers/ylk/formula/technology'),
		path: '/u/formula/technology',
		title: '工艺流程'
	},
	// 优料库-施工指导
	{
		component: require('@/pages/containers/ylk/formula/construction'),
		path: '/u/formula/construction',
		title: '施工指导'
	},
	// 优料库-配方-添加组分
	{
		component: require('@/pages/containers/ylk/formula/component'),
		path: '/u/formula/component',
		title: '添加配方成分'
	},
	// 优料库-编辑商品
	{
		component: require('@/pages/containers/ylk/product/edit'),
		path: '/u/product/edit',
		title: '填写产品表',
		backgroundColor: '#f5f5f5'
	},
	// 优料库-活动
	{
		component: require('@/pages/containers/ylk/product/activity'),
		path: '/u/product/activity',
		title: '填写产品表',
		backgroundColor: '#f5f5f5'
	},
	// 产品描述
	{
		component: require('@/pages/containers/ylk/product/introduction'),
		path: '/u/product/introduction',
		title: '产品描述',
	},
	// 储存条件
	{
		component: require('@/pages/containers/ylk/product/storage'),
		path: '/u/product/storage',
		title: '储存条件',
	},
	// 添加物性值
	{
		component: require('@/pages/containers/ylk/product/physical'),
		path: '/u/product/physical',
		title: '添加物性值',
	},
	// 选择产地
	{
		component: require('@/pages/containers/ylk/product/place'),
		path: '/u/product/place',
		title: '选择产地',
	},
	// 性能特点
	{
		component: require('@/pages/containers/ylk/product/performance'),
		path: '/u/product/performance',
		title: '性能特点',
	},
	// 选择物性
	{
		component: require('@/pages/containers/ylk/product/select-physical'),
		path: '/u/product/selectphysical',
		title: '选择物性',
	},
	// 选择生产商
	{
		component: require('@/pages/containers/ylk/product/select-manufacturer'),
		path: '/u/product/selectmanufacturer',
		title: '选择生产商',
	},
	{
		component: require('@/pages/containers/research/index'),
		path: '/research',
		title: '看数据',
	},
	{
		component: require('@/pages/containers/research/analysis'),
		path: '/research/analysis',
		title: '看数据',
	},
	{
		component: require('@/pages/containers/research/analysis-edit'),
		path: '/research/analysis-edit',
		title: '看数据',
	},
	{
		component: require('@/pages/containers/research/service'),
		path: '/research/service',
		title: '看数据',
	},
	{
		component: require('@/pages/containers/research/center'),
		path: '/research/center',
		title: '看数据',
	},
	{
		component: require('@/pages/containers/integral/index'),
		path: '/integral/index',
		title: '积分收支明细'
	},
	{
		component: require('@/pages/containers/integral/detail'),
		path: '/integral/detail',
		title: '积分收支明细'
	},
	{
		component: require('@/pages/containers/supplementary/index'),
		path: '/supplementary',
	},
	// {
	// 	component: require('@/pages/containers/integral/gold-coins'),
	// 	path: '/integral/goldcoins',
	// 	title: '春季采购节'
	// }
];

export default router;
